import { styled } from '@material-ui/styles';
import { Button } from '@material-ui/core';

export default styled(Button)({
    background: 'linear-gradient(180deg, #2CA1DC 0%, #3491DE 100%)',
    border: '1px solid rgba(59, 126, 222, 0.55)',
    color: 'white',
    height: 42,
});
